import React from "react";
import "./index.scss";
import { IMdaePopupContentProps } from "./index";
const MdaePopupContent: React.FC<IMdaePopupContentProps> = (props) => {
  return (
    <div className={props.className ? props.className : "mdae-popup-content"}>
      {props.children}
    </div>
  );
};
export { MdaePopupContent };
